import React, { useEffect, useState } from 'react';

import { SimplifiedSuggestion } from '@gumtree/ui-library/src/utils/suggestions-service';
import { updateUrlWithKeyValue } from '@gumtree/shared/src/util/url-params';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';
import { trackGA4PreNav } from '@gumtree/shared/src/util/ga4-shared';

import {
    Container,
    StyledChipWithVisibilityObserver,
    StyledWithChildrenVisibilityDetector,
} from './index.style';

export const onClick = async (suggestion: SimplifiedSuggestion, index: number, window: Window) => {
    trackV2(`ChipClick${index}`, suggestion.name, {});

    trackGA4PreNav<GA4.ChipInteraction>({
        event: 'chip_interaction',
        chipIndex: index,
        chipSearchTerm: suggestion.name,
    });

    const isSrp = window.location.pathname === '/search';
    const baseUrl = isSrp ? window.location.pathname + window.location.search : '/search';
    const urlWithQ = updateUrlWithKeyValue(baseUrl, 'q', suggestion.name);
    const redirectUrl = updateUrlWithKeyValue(
        urlWithQ as string,
        'search_category',
        suggestion.categorySeoName
    );

    window.location.href = redirectUrl as string;
};

const KeywordSuggestions = ({
    className,
    alternativeKeywordSuggestions,
}: {
    className?: string;
    alternativeKeywordSuggestions: SimplifiedSuggestion[];
}) => {
    const trimmedSuggestion = alternativeKeywordSuggestions.slice(0, 6);
    const [hasTriggeredChipRevealEvent, setHasTriggeredChipRevealEvent] = useState(false);

    useEffect(() => {
        if (hasTriggeredChipRevealEvent) {
            trackV2('ChipReveal', undefined, {});
        }
    }, [hasTriggeredChipRevealEvent]);

    const showComponent = trimmedSuggestion.length > 0;

    return (
        <Container className={className}>
            {showComponent && (
                <StyledWithChildrenVisibilityDetector
                    onLoad={(total, hidden) => {
                        const hasChips = total > 0;
                        const hasHidden = hidden > 0;
                        if (hasChips) {
                            trackV2('ChipShown', hasHidden ? 'ChipHidden' : 'ChipVisible', {});
                        }
                    }}
                >
                    {trimmedSuggestion.map((suggestion, index) => (
                        <StyledChipWithVisibilityObserver
                            key={suggestion.name}
                            onVisible={(isVisibleOnLoad) => {
                                if (!isVisibleOnLoad) {
                                    setHasTriggeredChipRevealEvent(true);
                                }
                            }}
                            label={suggestion.name}
                            onClick={() => {
                                onClick(suggestion, index, window);
                            }}
                        />
                    ))}
                </StyledWithChildrenVisibilityDetector>
            )}
        </Container>
    );
};

export default KeywordSuggestions;
